import { createNewSortInstance } from 'fast-sort'

import { ITableRow } from '@makyoapp/makyo-sdk/models/Table'

/** @deprecated */
function comparer(a: any, b: any, sortBy: string, isAsc: boolean) {
  if (!a[sortBy] && !b[sortBy]) return 0

  const isRand = sortBy === '#random#'
  if (isRand) {
    return [-1, 0, 1][Math.floor(Math.random() * 3)]
  }

  const aValue = a[sortBy]
  const bValue = b[sortBy]

  const isDate = !isNaN(new Date(aValue as string).getTime())
  const isBoolean = typeof aValue === 'boolean'
  const isNum = typeof aValue === 'number'

  if (isDate) {
    const aDate = new Date(aValue as string)
    const bDate = new Date(bValue as string)

    if (aDate.getTime() === bDate.getTime()) return 0
    if (aDate.getTime() < bDate.getTime()) {
      return isAsc ? -1 : 1
    }
    return isAsc ? 1 : -1
  }
  if (isBoolean) {
    if (aValue === bValue) return 0
    if (aValue === false && bValue === true) {
      return isAsc ? -1 : 1
    }
    return isAsc ? 1 : -1
  }
  if (isNum) {
    const aNum = (a[sortBy] as number) ?? 0
    const bNum = (b[sortBy] as number) ?? 0
    if (aNum < bNum) {
      return isAsc ? -1 : 1
    }
    if (aNum > bNum) {
      return isAsc ? 1 : -1
    }
    return 0
  }
  if (typeof aValue === 'string' && typeof bValue === 'string') {
    // String sorting (case-insensitive)
    const aStr = aValue.toLowerCase()
    const bStr = bValue.toLowerCase()

    if (aStr < bStr) return isAsc ? -1 : 1
    if (aStr > bStr) return isAsc ? 1 : -1
    return 0
  }
  return 0
}

export const naturalSort = createNewSortInstance({
  comparer: new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }).compare,
})

/**
 * Sort rows based on the sortSettings in app builder components.
 *
 * Used mainly in list component group
 */
export function sortData(rows: ITableRow[], sortType: string, sortBy?: string): ITableRow[] {
  const isAsc = sortType === 'asc'

  let result: ITableRow[] = []

  if (sortBy) {
    if (sortBy === '#random#') {
      result = [...rows].sort(() => [-1, 0, 1][Math.floor(Math.random() * 3)])
    } else {
      result = isAsc ? naturalSort(rows).asc((u) => u[sortBy]) : naturalSort(rows).desc((u) => u[sortBy])
    }
  } else {
    result = isAsc ? rows : [...(rows || [])].reverse()
  }

  return result
}
